/** Single base URL for all API calls – change only here. Reused for apiBaseAddress and dataApiBaseAddress. api-dev2.platex.co.uk is mapped to the API (CloudFront → EC2). */
const API_BASE_URL = 'api.platex.co.uk/api';

export const environment = {
  // PlateX assistant service (platex-assistant). Empty = widget hidden.
  assistantUrl: 'https://7htcen5doxdrj2hztjgkrwad3m0gfohf.lambda-url.eu-west-2.on.aws',
  assistantDevBypass: false, // local dev only: show widget without an admin login
  localDevAccess: false, // never on a deployed build (see src/app/dev-access.ts)
  production: true,
  stripe_key:
    'pk_test_51Ijh3dCfbeInu3gtjPFL25XYrQhHjNNI2cofFNmChWJsx023G5RJcAkl9dc0sFdcHBzcOpV8q58s0400QuUYlFAE0077EnIoWJ',
  paypal_client_id:
    'AUj49w7FVgvize6E6WaY_lLYYw8sMgVxixolIWHzE2dAPq-nwQoncML3AUX5SD1tzAhCDvj2eFwNZfO9',
  paypal_live_client_id:
    'AVUwGcHwUCZ7l2xqpA5VNSTgF9UkQ-31Juk8QzCgv3WCQj-QeRIl8Bd946sdXreEnlUcBf3ptYvKcncI',
  versionNo: require('../../package.json').version,
  buildNo: '0',
  apiProtocol: 'https://',
  platoProtocol: 'https://',
  apiBaseAddress: API_BASE_URL,
  dataApiProtocol: 'https://',
  dataApiBaseAddress: API_BASE_URL,
  platoBaseAddress: 'plato.platex.co.uk',
  platoSearchProtocol: 'https://',
  platoSearchBaseAddress:
    '81ugpzvec7.execute-api.eu-west-2.amazonaws.com/Prod/search',
  // Canonical plato-search — must always reach the real plato-search Lambda
  // regardless of the platex-dev2 Amplify Mode 2 sed rewrite. Used by
  // new-release and any other code path Mode 2 does not yet implement.
  //
  // IMPORTANT: the URL below is intentionally split across `+` concatenation
  // so the Amplify branch buildSpec sed cannot match it. The sed matches the
  // contiguous plato-search host+stage literal on a single line and rewrites
  // it to Mode 2. Keeping the host and stage halves separated by `' + '`
  // guarantees the sed skips this line during the platex-dev2 build, leaving
  // the canonical URL pointing at plato-search while platoSearchBaseAddress
  // above gets rewritten to Mode 2. Do not collapse this concatenation back
  // into a single literal — and do not write the contiguous URL in any
  // comment in this file, since the sed will rewrite that too.
  platoSearchCanonicalProtocol: 'https://',
  platoSearchCanonicalBaseAddress:
    '81ugpzvec7.execute-api.eu-west-2.amazonaws.com' + '/Prod/search',
  // Editorial Intelligence is a Dev2-only proof of concept and is DISABLED in
  // production: the admin tab is hidden and the editorial routes are guarded
  // (see EditorialEnabledGuard). The host is intentionally blank here so no
  // real production (platex.co.uk) build can ever call the editorial API.
  // The platex-dev2 Amplify buildSpec sed-flips editorialEnabled -> true and
  // sets editorialApiBaseAddress for the dev2 build ONLY (mirrors Mode 2).
  editorialEnabled: false,
  editorialApiProtocol: 'https://',
  editorialApiBaseAddress: '',
  // DEV2-only isolated Names stack (plato-names-dev2). The interceptor uses this
  // ONLY when the runtime host is dev2; a genuine production host falls back to
  // plato-search canonical, so prod is never pointed at dev2 infra.
  namesRegisterDev2BaseAddress: '13dfkzcsnh.execute-api.eu-west-2.amazonaws.com/search',
  // DEV2-only plate-photo upload inbox (Plate Image Researcher). Used ONLY when
  // the runtime host is dev2; stages member uploads to a private S3 inbox for an
  // editor to promote. A genuine production host never calls it (host-gated).
  plateInboxUrl: 'https://r4vh63ky5l26thjciq7gqt4hea0xdpvw.lambda-url.eu-west-2.on.aws/',
  plateInboxToken: 'ChnBOjLVf99GOgVkmat2vXXu',
  local_apiProtocol: '',
  local_platoProtocol: '',
  local_apiBaseAddress: '',
  local_platoBaseAddress: '',
  appleClientId: '',
  appleRedirectUri: '',
  checkout_enabled: false,
  latestRelease: '26',

  // -------------------------------------------------------------------------
  // Mode 2 shadow deployment
  // -------------------------------------------------------------------------
  // useLiveV2: true  → Mode 2 is the primary visible search. Legacy runs
  //                    in shadow mode only (async, never blocks rendering).
  // useLiveV2: false → legacy super-search becomes primary.
  //
  // SET false: Dev2 now runs the SAME completed production search system as
  // production (one production search system serving two frontend designs).
  // The primary path is searchLegacy() — the six-call progressive merge
  // (search_v2 fast Plato Mode 1 + search_v3 x2 + synonym + pattern + perfect
  // + extended) with the 2f671e2b upsert/mergeRegistration ranking + seller/
  // price preservation. Every leg resolves to the production plato-search
  // endpoint (platoSearchBaseAddress, no longer sed-rewritten to Mode 2 — see
  // the branch buildSpec). The separate Mode 2 gateway path (searchMode2Path /
  // mode2BaseAddress) is retired from active use; set this back to true only to
  // roll Mode 2 back in.
  useLiveV2: false,
  liveV2CompareEnabled: true,

  // Production Mode 2 search Lambda endpoint.
  // Format: '<api-id>.execute-api.eu-west-2.amazonaws.com/search'
  // (no trailing slash, no protocol — those come from mode2Protocol).
  // Populate after `terraform apply` in the gallant-morse worktree:
  //   terraform output search_prod_search_url
  // then strip the https:// prefix and set the remainder here.
  // dev2 live_v2 gateway ($default proxy → plato-search-dev2-mode2): serves
  // search_v3 (Close Matches), extended-search (Current/Prefix) and synonym
  // (Similar). The previous value (cwkcq8t3h8/search_mode2) was a broken
  // Lambda (Service Unavailable) and must not be deployed.
  mode2Protocol: 'https://',
  mode2BaseAddress: 'hbf2dbkvj3.execute-api.eu-west-2.amazonaws.com',

  // Shadow log endpoint — POST /shadow-log and PATCH /shadow-log/:id.
  // Populate from: terraform output shadow_log_post_url (strip https:// prefix).
  shadowLogProtocol: 'https://',
  shadowLogBaseAddress: '',  // TODO: set after terraform apply

  // PRODUCTION LINKS
  // stripeProducts: {
  //   monthly_listing: 'https://buy.stripe.com/4gwfZXeMce6i7aEeUX',
  //   '3_month_listing': 'https://buy.stripe.com/eVa9Bz0VmfamgLe004',
  //   yearly_listing: 'https://buy.stripe.com/28o00Z6fG2nAeD63ch',
  // },

  // TEST LINKS
  stripeProducts: {
    platex_commission: '/advert-edit/',
    monthly_listing: 'https://buy.stripe.com/test_14k8At4lg9gUa8U288',
    '3_month_listing': 'https://buy.stripe.com/test_9AQ181aJE8cQ6WI7sv',
    yearly_listing: 'https://buy.stripe.com/test_6oE5ohg3Y8cQgxifZ2',
  },
};
